import ServiceCRUD from '../../../../services/ServiceGasOrder';

class Service extends ServiceCRUD {
  constructor() {
    super('api/exportar-oportunidades-csv');
  }
}

export default new Service();
